<template>
<div style="height:80px">
  <div class="footer">
    <div class="cop">Copyright ©  2019-{{ Year }} 湖南兆物信链科技集团有限公司 版权所有
        <div class="btn">
            <a style="color: #dbdbdb" href="https://beian.miit.gov.cn/" target="_blank">湘ICP备19019059号</a>&nbsp;
            <a style="color: #dbdbdb" href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">湘公网安备 43010502001004号</a><br>
          <a style="color: #dbdbdb" href="tel://073185584896">联系电话：0731-85584896</a>
          <el-popover placement="bottom" trigger="click" title="微信公众号" popper-class="popover-self"><img src="./../assets/home/weixin.png" alt="微信公众号">
                <el-button slot="reference"><span><img src="../assets/head/wechar.jpg"></span></el-button>
            </el-popover>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "mobile-footer",
  data() {
    return {
      Year: new Date().getFullYear(),
    }
  },

}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  position: fixed;
  // z-index: -1;
  bottom: 0px;
  height: 80px;
  background-color: #066DFF;
  z-index: 100;

  .nav {
    margin: 0 auto;
    max-width: 640px;
    height: 320px;
    display: flex;
    /*bottom: 38px;*/
    .nav_content {
      width: 25%;
      height: 70%;
      padding: 50px 0 0 0;
      /*border-right: 1px solid #33363c;*/
      .name {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
        padding-bottom: 20px;
      }

      .lable {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606673;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }

  .cop {

    height: 48.5%;
    width: 100%;
    text-align: center;
    line-height: 22px;
    color: #dbdbdb;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 80;
    position: absolute;

    .btn{
        /deep/ .el-popper{
            width: 160px;
        }
        .popover-self{
          img{
            width: 100px;
          }
        }
        button{
            padding: 0px;
        }
        span {
            float: right;
            height: 35px;
                img{
                    height: 35px;
                }
        }
    }

  }
}

</style>
